module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/polygon-17ea1a13bd3094f5275d72dc6884c415.svg";